import React, { useState, useEffect, useRef } from 'react'
import './Navbar.css'
import { Link, useLocation } from 'react-router-dom';
import cart_icon from '../Assets/Cart.png'
import { useCart } from '../Cart'
import { useAuth } from '../../Context/AuthContext'
import Search from '../Search/Search'

const pathToMenu = {
  '/': 'home',
  '/DogProducts': 'dog_products',
  '/CatProducts': 'cat_products',
  '/AboutUs': 'about',
  '/ContactUs': 'contact',
}

const Navbar = () => {
  const location = useLocation()
  const [menu, setMenu] = useState(() => pathToMenu[location.pathname] || 'home');
  const [mobileOpen, setMobileOpen] = useState(false)
  const [userDropdownOpen, setUserDropdownOpen] = useState(false)
  const { cartCount } = useCart()
  const { user, logout } = useAuth()
  const dropdownRef = useRef(null)

  useEffect(() => {
    setMobileOpen(false)
  }, [location.pathname])

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setUserDropdownOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleNavClick = (menuItem) => {
    setMenu(menuItem)
    setMobileOpen(false)
  }

  return (
    <nav className='navbar'>

      <Link to='/' className='nav-logo' onClick={() => handleNavClick('home')}>
        <span className='nav-logo-text'>ArrAndArr</span>
      </Link>

      <div className='nav-search-desktop'>
        <Search compact />
      </div>

      <button
        className='nav-hamburger'
        onClick={() => setMobileOpen(prev => !prev)}
        aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={mobileOpen}
      >
        <span className={`hamburger-line ${mobileOpen ? 'open' : ''}`} />
        <span className={`hamburger-line ${mobileOpen ? 'open' : ''}`} />
        <span className={`hamburger-line ${mobileOpen ? 'open' : ''}`} />
      </button>

      <ul className={`nav-menu${mobileOpen ? ' mobile-menu-open' : ''}`}>

        <li onClick={() => handleNavClick('home')}>
          <Link to='/'>Home</Link>
          {menu === 'home' && <hr />}
        </li>
        <li onClick={() => handleNavClick('dog_products')}>
          <Link to='/DogProducts'>Dog Products</Link>
          {menu === 'dog_products' && <hr />}
        </li>
        <li onClick={() => handleNavClick('cat_products')}>
          <Link to='/CatProducts'>Cat Products</Link>
          {menu === 'cat_products' && <hr />}
        </li>
        <li onClick={() => handleNavClick('about')}>
          <Link to='/AboutUs'>About Us</Link>
          {menu === 'about' && <hr />}
        </li>
        <li onClick={() => handleNavClick('contact')}>
          <Link to='/ContactUs'>Contact Us</Link>
          {menu === 'contact' && <hr />}
        </li>
      </ul>

      <div className='nav-right'>
        <div className='nav-search-mobile'>
          <Search compact />
        </div>

        <div className='nav-user' ref={dropdownRef}>
          <button
            className='nav-user-btn'
            onClick={() => setUserDropdownOpen(prev => !prev)}
            aria-label='Account menu'
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className='nav-user-icon'>
              <path d="M10 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM3.465 14.493a1.23 1.23 0 0 0 .41 1.412A9.957 9.957 0 0 0 10 18c2.31 0 4.438-.784 6.131-2.1.43-.333.604-.903.408-1.41a7.002 7.002 0 0 0-13.074.003Z" />
            </svg>
            <span className='nav-user-label'>Account</span>
          </button>

          {userDropdownOpen && (
            <div className='nav-dropdown'>
              {user ? (
                <>
                  <div className='nav-dropdown-header'>
                    <span className='nav-dropdown-name'>{user.name || user.email}</span>
                  </div>
                  <Link to='/Profile' onClick={() => setUserDropdownOpen(false)}>My Profile</Link>
                  <Link to='/Cart' onClick={() => setUserDropdownOpen(false)}>My Cart</Link>
                  <Link to='/AboutUs' onClick={() => setUserDropdownOpen(false)}>About Us</Link>
                  <button className='nav-dropdown-logout' onClick={() => { logout(); setUserDropdownOpen(false) }}>
                    Log Out
                  </button>
                </>
              ) : (
                <>
                  <Link to='/LogIn' onClick={() => setUserDropdownOpen(false)}>Log In</Link>
                  <Link to='/SignUp' onClick={() => setUserDropdownOpen(false)}>Create Account</Link>
                  <div className='nav-dropdown-divider' />
                  <Link to='/AboutUs' onClick={() => setUserDropdownOpen(false)}>About Us</Link>
                </>
              )}
            </div>
          )}
        </div>

        <div className='nav-cart-wrap'>
          <Link to='/Cart'>
            <img src={cart_icon} alt='Cart Icon' />
          </Link>
          {cartCount > 0 && <div className='nav-cart-count'>{cartCount}</div>}
        </div>
      </div>

    </nav>
  )
}

export default Navbar
